import { createFormAction } from 'redux-form-saga'
export const FORM_KEY = 'SLIDER_FORM_KEY'
export const SliderFormAction = createFormAction(FORM_KEY)

